export default __webpack_public_path__ + "static/media/China02.921b9819.obj";